import React from 'react';
import PropTypes from 'prop-types';


import * as styleUtils from '../../../../utils/styleUtils';

import styles from './FormActions.scss';


function FormActions({children, cssClass}) {

    return (
        <div className={styleUtils.toClasses(styles.formActions, cssClass && cssClass)}>

            {children}

        </div>
    );
}


FormActions.propTypes = {
    children: PropTypes.any,
    cssClass: PropTypes.string
};


export default FormActions;
